import CreatedSurvey from './CreatedSurvey';

export default CreatedSurvey;
